import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
const rows = [{
  label: 'Ruta Fertilidad Masculina (6 Tomos Premium)',
  value: 'USD 97'
}, {
  label: '5 Bonos Clínicos Exclusivos',
  value: 'USD 140'
}];
export function Offer() {
  return <section id="oferta" className="w-full scroll-mt-6 bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-159" data-mp="1hqs4e1thlbhf">
      <div className="mx-auto max-w-2xl" data-id="element-160" data-mp="u0xv1u8dm51x">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy-900 sm:text-4xl" data-id="element-161" data-mp="p0jv6zgxi1ez">
          🏆 Oferta Especial de Lanzamiento
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl border-2 border-navy-900/10 bg-white shadow-card" data-id="element-162" data-mp="yxxydxductpc">
          <div className="bg-navy-950 px-5 py-3 sm:px-7" data-id="element-163" data-mp="2fbxvl0lay58w">
            <p className="text-[11px] font-extrabold uppercase tracking-widest text-gold-400 sm:text-xs" data-id="element-164" data-mp="2fad27eaq4scm">
              Lo que recibirás
            </p>
          </div>

          <ul className="divide-y divide-navy-800/10 px-5 sm:px-7" data-id="element-165" data-mp="pj5sehrdw6au">
            {rows.map(row => <li key={row.label} className="flex items-start justify-between gap-4 py-4" data-id="element-166" data-mp="ui9069yr0qmi">
                <span className="text-[13.5px] font-medium leading-snug text-navy-900 sm:text-base" data-id="element-167" data-mp="zjg6e4l8thr2">
                  {row.label}
                </span>
                <span className="shrink-0 text-[13.5px] font-bold text-navy-800/60 line-through sm:text-base" data-id="element-168" data-mp="13hnmcx7vuf17">
                  {row.value}
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-4 py-4" data-id="element-169" data-mp="bqg426odupak">
              <span className="font-display text-[15px] font-black uppercase text-navy-900 sm:text-lg" data-id="element-170" data-mp="fsukkk4kxcyo">
                Valor total
              </span>
              <span className="font-display text-[15px] font-black text-navy-900 line-through sm:text-lg" data-id="element-171" data-mp="3k95jac2dyth4">
                USD 237
              </span>
            </li>
          </ul>

          <div className="border-t border-navy-800/10 bg-violet-50 px-5 py-7 text-center sm:px-7" data-id="element-172" data-mp="vfqw9zv6z8r5">
            <p className="text-[13px] font-semibold uppercase tracking-wide text-navy-800/70 sm:text-sm" data-id="element-173" data-mp="qgnq2c3h6whl">
              Hoy puedes acceder a todo por solo
            </p>
            <p className="mt-2 flex items-end justify-center gap-2" data-id="element-174" data-mp="154r13zwdkyd9">
              <span className="font-display text-5xl font-black leading-none text-violet-700 sm:text-6xl" data-id="element-175" data-mp="107s51bt5ihcf">
                USD 15
              </span>
            </p>
            <p className="mt-3 text-[13px] leading-relaxed text-navy-800/75 sm:text-[15px]" data-id="element-176" data-mp="7i1oyx7yl5do">
              Una inversión menor que el costo de una consulta médica, con un recurso que podrás
              utilizar durante años.
            </p>

            <div className="mt-5" data-id="element-177" data-mp="heehhrrrpd6u">
              <ScarcityBar data-id="element-178" data-mp="hibzub6iu0po" />
            </div>

            <div className="mt-6" data-id="element-179" data-mp="1wvoqov3g42ui">
              <CtaButton pulse subline="" data-id="element-180" data-mp="1wysz64ny1kqz" />
              <p className="mt-3 text-[11px] font-medium leading-relaxed text-navy-800/70 sm:text-sm" data-id="element-181" data-mp="1svo2iiqjoda9">
                Descarga inmediata · Pago único · Acceso de por vida · Garantía de 7 días
              </p>
            </div>

            <Countdown data-id="element-182" data-mp="25eibmom1ood3" />

            <p className="mx-auto mt-5 flex max-w-xs items-start justify-center gap-2 rounded-2xl bg-white px-4 py-3 text-left text-[12px] leading-snug text-navy-800/80 sm:text-[13.5px]" data-id="element-183" data-mp="25bnogpbncpfz">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-violet-600" aria-hidden="true" data-id="element-184" data-mp="1vfszzdkqs05a" />
              <span data-id="element-185" data-mp="2j5x21gia7ru6">
                <strong className="font-bold text-navy-900" data-id="element-186" data-mp="2j7hpkm66iaij">Puedes pagar en la moneda de tu país.</strong>{' '}
                El cambio de moneda se realiza de forma automática en el checkout.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}